var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCkFooterEasyReturns21(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h40v40H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)",
    fill: "#121212"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.183 8.192c-1.383-1.91-3.788-2.452-5.146-3.445-1.343-.983-2.593-3.121-4.853-3.858-2.197-.717-4.443.255-6.184.255-1.741 0-3.987-.972-6.184-.256-2.26.738-3.51 2.877-4.853 3.859-1.357.992-3.763 1.536-5.146 3.445-1.37 1.893-1.147 4.352-1.674 5.982C1.64 15.726 0 17.588 0 20c0 2.413 1.64 4.269 2.143 5.826.527 1.634.302 4.088 1.674 5.982 1.383 1.91 3.788 2.452 5.146 3.445 1.343.983 2.593 3.121 4.853 3.859 2.195.716 4.445-.256 6.184-.256 1.737 0 3.992.97 6.184.256 2.26-.738 3.51-2.876 4.853-3.859 1.357-.992 3.763-1.536 5.145-3.445 1.371-1.892 1.148-4.351 1.675-5.982C38.36 24.274 40 22.412 40 20c0-2.413-1.639-4.268-2.143-5.826-.527-1.634-.302-4.088-1.674-5.982zm-2.531 21.783c-.789 1.09-2.86 1.586-4.46 2.756-1.58 1.156-2.689 2.99-3.978 3.41-1.22.398-3.206-.41-5.214-.41-2.022 0-3.989.81-5.214.41-1.289-.42-2.396-2.253-3.979-3.41-1.589-1.163-3.672-1.67-4.459-2.756-.775-1.07-.62-3.217-1.232-5.11-.599-1.854-1.991-3.46-1.991-4.865 0-1.406 1.39-3.006 1.991-4.865.615-1.904.454-4.036 1.232-5.11.788-1.088 2.862-1.587 4.46-2.756 1.586-1.16 2.687-2.988 3.978-3.41 1.218-.397 3.212.41 5.214.41 2.026 0 3.988-.81 5.214-.41 1.289.42 2.396 2.253 3.979 3.41 1.589 1.163 3.672 1.67 4.459 2.756.775 1.071.62 3.215 1.232 5.11.599 1.854 1.991 3.46 1.991 4.865 0 1.406-1.39 3.007-1.991 4.865-.615 1.905-.454 4.036-1.232 5.11zm-6.453-12.78-7.821 7.82c-.61.61-1.6.61-2.21 0l-4.367-4.366a1.562 1.562 0 1 1 2.21-2.21l3.262 3.262 6.716-6.716a1.562 1.562 0 1 1 2.21 2.21z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCkFooterEasyReturns21);
export default __webpack_public_path__ + "static/media/icon-ck-footer-easy-returns-21.6378fa72a99daf40113152bd0f18af0f.svg";
export { ForwardRef as ReactComponent };